import { Navigate, Outlet } from 'react-router-dom'
import { paths } from '@/config/paths'
import { useRole } from '@/hooks/useRole'

const AdminRoot = () => {
  const { hasAccess } = useRole()

  if (!hasAccess('admin')) {
    return <Navigate to={paths.app.dashboard.getHref()} replace />
  }

  return <Outlet />
}

export { AdminRoot }
